import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ScrollTagsComponent } from './tag-scroll.component';

@Directive({
  selector: '[oirScrollTag]'
})
export class ScrollTagDirective {
  static readonly hideArrowTime = 310;
  static readonly defaultScrollSize = 200;
  static readonly scrollTime = 500;
  static readonly addScrollSize = 50;
  static readonly arrowWidth = 50;
  readonly arrow;
  mouseLeft: boolean;
  parentComponent: ScrollTagsComponent;
  @Input('oirScrollTag') direction: string;
  constructor(readonly elementRef: ElementRef, readonly parentCmp: ScrollTagsComponent) {
    this.mouseLeft = false;
    this.parentComponent = parentCmp;
    if (this.elementRef.nativeElement.classList.contains('right')) {
      this.arrow = this.elementRef;
    }
  }

  @HostListener('mouseover', ['$event', '$event.target']) onMouseOver(): void {
    const target = this.elementRef.nativeElement.parentNode.getElementsByClassName('tag-scroll-body')[0];
    const arrow = this.elementRef.nativeElement;

    this.mouseLeft = false;
    switch (this.direction) {
      case 'left':
        if (arrow.classList.contains('visible')) {this.scrollLeft(target); }
        break;
      case 'right':
        if (arrow.classList.contains('visible')) {this.scrollRight(target); }
        break;
      default:
        break;
      }
    this.parentComponent.checkArrowVisibility();
  }

  @HostListener('mouseleave', ['$event', '$event.target']) onMouseLeave(): void {
    this.mouseLeft = true;
  }

  @HostListener('window:resize', ['$event']) onResize(): void {
    this.parentComponent.checkArrowVisibility();
  }

  private scrollLeft(target: any, scrollsize?: number): void {
    let scrollSize = scrollsize || ScrollTagDirective.defaultScrollSize;

    const rightButton = target.parentNode.getElementsByClassName('scroll right')[0];
    rightButton.classList.remove('hidden');
    setTimeout(() => { rightButton.classList.add('visible'); });

    if (parseInt(target.offsetLeft) + scrollSize <= 0) {
      target.style.left = `${(parseInt(target.offsetLeft) + scrollSize).toString()}px`;
      // call scrollLeft method again after half a second if arrow remains hovered
      setTimeout(() => {
        if (!this.mouseLeft) {
          this.scrollLeft(target, scrollSize += ScrollTagDirective.addScrollSize);
        }
        }, ScrollTagDirective.scrollTime);
    } else {
      target.style.left = '0px';
      const leftButton = target.parentNode.getElementsByClassName('scroll left')[0];
      leftButton.classList.remove('visible');
      setTimeout(() => leftButton.classList.add('hidden'), ScrollTagDirective.hideArrowTime);
    }
  }

  private scrollRight(target: any, scrollsize?: number): void {
    let scrollSize = scrollsize || ScrollTagDirective.defaultScrollSize;

    const leftButton = target.parentNode.getElementsByClassName('scroll left')[0];
    leftButton.classList.remove('hidden');
    setTimeout(() => { leftButton.classList.add('visible'); });

    if ((target.offsetLeft - scrollSize) > (target.clientWidth - (parseInt(target.scrollWidth) + ScrollTagDirective.arrowWidth))) {
      target.style.left = `${(target.offsetLeft - scrollSize).toString()}px`;
      setTimeout(() => {
        if (!this.mouseLeft) {
          this.scrollRight(target,  scrollSize += ScrollTagDirective.addScrollSize);
        }
        }, ScrollTagDirective.scrollTime);
    } else {
      target.style.left = `${(target.clientWidth - target.scrollWidth).toString()}px`;

      const rightButton = target.parentNode.getElementsByClassName('scroll right')[0];
      rightButton.classList.remove('visible');

      setTimeout(() => rightButton.classList.add('hidden'), ScrollTagDirective.hideArrowTime);
    }
  }

}
